import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SharedService } from "./shared.service";
import {delay} from "rxjs/operators";

@Injectable()
export class CatalogService {
    public setupAPI: string = "/svcs/session_catalog/setup";
    public setupAttendeeAPI: string = "/svcs/session_catalog/app/sessionCatalog";
    public setupConfigAPI: string = "/svcs/session_catalog/setup/config";
    public userInfoAPI: string = '/svcs/users/findByUUID'

    constructor(private http: HttpClient, public sharedService: SharedService) {}

    public findByCatalogUUID(catalogUUID) {
        let url;
        if (this.sharedService.redirectTo == "admin" || this.sharedService.redirectTo == "preview") {
            url = this.setupAPI;
        } else {
            url = this.setupAttendeeAPI;
        }

        return this.http.get(url + "?catalogUUID=" + catalogUUID, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public findByCatalogUUIDES(catalogUUID) {
        let url = this.setupAttendeeAPI;

        return this.http.get(url + "?catalogUUID=" + catalogUUID, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public findLoggedInUserInfo(accountId, uuid) {
        let url = this.userInfoAPI;

        return this.http.get(url + "?accountId=" + accountId + '&uuid=' + uuid , {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public saveSetup(setup: any) {
        let url = this.setupAPI;
        if (setup.id != null) {
            url = url + "/" + setup.id;
        }
        return this.http.post(url, JSON.stringify(setup), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public publishCatalog(setupConfig: any) {
        const payload = JSON.stringify(setupConfig);
        const url = this.setupAPI +  "/publish";

        const resp = this.http.post(url, payload, {
            observe: "response",
            headers: this.sharedService.headers
        });
        const delayedPublishRequest = resp.pipe(delay(500));
        delayedPublishRequest.subscribe((response) => {
            this.http.post(this.setupAPI +  "/syncS3Data", payload, {headers: this.sharedService.headers}).toPromise();
        });
        return resp;
    }

    public saveSetupConfig(setupConfig: any) {
        let url = this.setupConfigAPI;
        if (setupConfig.id != null) {
            url = url + "/" + setupConfig.id;
        }
        return this.http.post(url, JSON.stringify(setupConfig), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getCustomFieldList(params) {
        let url = "/svcs/session_catalog/app/confCustomField?active=true&limit=-1&name=&name.dir=asc&page=0&sort=name";
        return this.http.get(url, {
            params: params,
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public saveCss(formData: FormData) {
        this.sharedService.isUpload = true;
        return this.http.post(
            `/svcs/api/3.1/accounts/${this.sharedService.accountUUID}/events/${this.sharedService.eventUUID}/assetsv2`,
            formData,
            {
                observe: "response",
                headers: {}
            }
        );
    }

    public saveJSON(formData: FormData) {
        this.sharedService.isUpload = true;
        return this.http.post(
            `/svcs/api/3.1/accounts/${this.sharedService.accountUUID}/events/${this.sharedService.eventUUID}/assetsv2`,
            formData,
            {
                observe: "response",
                headers: {}
            }
        );
    }

    public getJSONService(fileURL) {
        return this.http.get(fileURL,
            {
                observe: "response",
                headers: this.sharedService.headers
            })
    }

    public getTimeZone() {
        return this.http.get(`/svcs/session_catalog/app/time_zones`,
            {
                observe: "response",
                headers: this.sharedService.headers
            })
    }

    public getAccountclient(accountUUID) {
        return this.http.get(`/svcs/session_catalog/app/calendarPreference` + "?accountUUID=" + accountUUID,
            {
                observe: "response",
                headers: this.sharedService.headers
            })
    }

    public getLayoutConfig(catalogUUID) {
        return this.http.get(`/svcs/session_catalog/app/layout_config` + "?catalogUUID=" + catalogUUID,
            {
                observe: "response",
                headers: this.sharedService.headers
            })
    }

    public saveFilter(preSetFilter: any) {
        let url = "/svcs/session_catalog/app/saveFilter";
        return this.http.post(url, JSON.stringify(preSetFilter), {
            observe: "response",
            headers: this.sharedService.headers
        });
   	}

    public getFilterPresetOptions() {
	    let url = "/svcs/session_catalog/app/getFilterPresetOptions";
        return this.http.get(url, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }
    
    public deleteFilter(id) {
        let url = `/svcs/session_catalog/app/deleteFilterOptions/${id}`;
        return this.http.get(url, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }
    
    public findCatalogRedirectToScalingCatalog(params) {
        let url = "/svcs/session_catalog/app/redirectToScalingCatalog?timestamp="+ new Date().getTime();
        return this.http.get(url, {
            params: params,
            observe: "response",
            headers: this.sharedService.headers
        });
    }
    
}
